import { Phone } from "lucide-react";
import smartlyMainLogo from "@/assets/smartly-main-logo.svg";
import { useLandingContent } from "@/lib/landing/LandingContentProvider";
import { phoneHref } from "@/lib/landing/resolve";

export default function LandingHeader({ onCall }: { onCall: () => void }) {
  const { content } = useLandingContent();
  const href = phoneHref(content.phone);
  return (
    <header className="landing-band-dark h-[60px] border-b border-landing-border sm:h-[72px]">
      <div className="landing-container flex h-full items-center justify-between">
        <div
          className="flex min-w-0 items-center gap-2"
          aria-label="Smartly Technologies"
        >
          <img
            src={smartlyMainLogo}
            alt="Smartly"
            className="h-[21px] w-auto sm:h-[26px]"
          />
          <span className="landing-brand-text font-display text-[17px] font-bold text-landing-on-dark sm:text-[21px]">
            Technologies
          </span>
        </div>
        <a
          href={href}
          onClick={onCall}
          data-lp-tel=""
          className="hidden min-h-11 items-center gap-2.5 text-landing-on-dark transition-colors hover:text-landing-red-soft md:flex"
        >
          <span data-lp="header.callLabel" className="text-[13.5px] text-landing-on-dark-muted">
            {content.header.callLabel}
          </span>
          <Phone className="h-4 w-4 text-landing-red-soft" />
          <span data-lp="phone" className="font-display text-[19px] font-semibold">
            {content.phone}
          </span>
        </a>
        <a
          href={href}
          onClick={onCall}
          data-lp-tel=""
          aria-label={`Call ${content.phone}`}
          className="flex h-11 w-11 items-center justify-center rounded-full border-[1.5px] border-landing-headline text-landing-red-soft md:hidden"
        >
          <Phone className="h-5 w-5" />
        </a>
      </div>
    </header>
  );
}
